import "./style.scss";
import GiftIcon from "./img/gift.svg";
import EmailIcon from "./img/email.svg";
import SectionHeader from "@components/SectionHeader";

export default function OrderTab({ content }) {
  return (
    <div className="how-to-recommend">
      <SectionHeader>
        Wie kann ich <strong>empfehlen?</strong>
      </SectionHeader>
      <div className="card-grid">
        <div className="card blue">
          <div className="card-wrapper">
            <div className="card-header">
              <span className="counter">1</span>
              <div className="title-wrapper">
                <span className="icon">
                  <img src={EmailIcon} alt="email-icon" />
                </span>
                <h3 className="title">
                  <strong>Empfehlungslink senden</strong>
                </h3>
              </div>
            </div>
            <p className="desc">
              Kopiere den generierten Link und schicke ihn an einen Freund.
            </p>
          </div>
        </div>
        <div className="card blue">
          <div className="card-wrapper">
            <div className="card-header">
              <span className="counter">2</span>
              <div className="title-wrapper">
                <span className="icon">
                  <img src={GiftIcon} alt="gift-icon" />
                </span>
                <h3 className="title">
                  <strong>Hol dir deine Belohnung!</strong>
                </h3>
              </div>
            </div>
            <p className="desc">
              {content !== "/invite/vuse"
                ? "Du erhältst einen 15€ Wunschgutschein, sobald dein Freund einen glo™ Heater mit deinem Empfehlungslink gekauft hat. Der Wunschgutschein wird 14 Tage nach dem Einkauf per Mail versendet."
                : "Nachdem dein/e Freund/in die erste Bestellung mit deinem Empfehlungslink aufgegeben hat, gibt es einen zweiten 15 € Gutschein für dich per Mail."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
